import React, { ReactElement } from 'react';

interface IconProps {
  color?: string;
}

const PrivacySafeDatingTipsIcon = ({ color = '#E2C92D' }: IconProps): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} fill="none">
      <mask
        id="a"
        width={26}
        height={26}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="#D9D9D9" d="M0 0h26v26H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill={color}
          d="M18.417 23.833c-1.499 0-2.776-.528-3.833-1.584C13.529 21.193 13 19.915 13 18.416c0-1.498.528-2.776 1.585-3.832C15.64 13.528 16.918 13 18.416 13c1.498 0 2.776.528 3.832 1.584s1.585 2.334 1.585 3.832c0 1.499-.529 2.776-1.585 3.833-1.056 1.056-2.334 1.584-3.832 1.584ZM4.113 12.025v-5.06c0-.517.148-.981.445-1.394a2.514 2.514 0 0 1 1.158-.896l6.422-2.405c.283-.103.57-.155.862-.155.292 0 .58.052.862.155l6.423 2.405c.475.184.861.483 1.158.896.296.413.444.877.444 1.393v3.149c0 .359-.156.644-.468.855a1.092 1.092 0 0 1-1 .142 8.094 8.094 0 0 0-.987-.206 7.133 7.133 0 0 0-1.015-.07c-2.095 0-3.882.74-5.363 2.22-1.48 1.48-2.22 3.268-2.22 5.362 0 .574.067 1.137.203 1.69.135.553.342 1.13.62 1.733.176.378.12.717-.168 1.019-.287.3-.622.365-1.004.194a9.644 9.644 0 0 1-2.102-1.45 12.243 12.243 0 0 1-1.74-1.96 13.147 13.147 0 0 1-1.863-3.575 12.424 12.424 0 0 1-.667-4.042Zm14.317 6.391c.451 0 .835-.158 1.15-.474.317-.316.475-.7.475-1.15 0-.452-.158-.836-.474-1.152a1.567 1.567 0 0 0-1.151-.474c-.452 0-.835.158-1.151.474-.316.316-.474.7-.474 1.151 0 .452.158.835.474 1.151.316.316.7.474 1.15.474Zm0 3.25c.438 0 .85-.08 1.237-.24.386-.161.733-.396 1.04-.703a.48.48 0 0 0 .128-.411c-.023-.157-.115-.274-.276-.35a4.627 4.627 0 0 0-1.041-.35 5.325 5.325 0 0 0-2.183.003c-.36.077-.706.192-1.04.346-.163.077-.255.194-.277.35a.48.48 0 0 0 .128.412c.307.307.655.542 1.043.702.389.161.802.241 1.24.241Z"
        />
      </g>
    </svg>
  );
};

export default PrivacySafeDatingTipsIcon;
